<template>
  <div>
    <!-- <div class="user-name">
      {{ userInfo ? userInfo.username : '-' }}
    </div> -->
    <el-menu class="navbar" mode="horizontal">
      <hamburger
        class="hamburger-container"
        :toggleClick="toggleSideBar"
        :isActive="sidebar.opened"
      ></hamburger>
      <breadcrumb></breadcrumb>

      <!-- <el-autocomplete
        class="inline-input"
        style="position: absolute; right: 160px; width: 160px"
        v-model="querySearchData"
        :fetch-suggestions="querySearch"
        placeholder="输入菜单名或路径"
        @select="handleSelect"
      ></el-autocomplete> -->

      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <div class="user-name">
            <el-avatar
              v-bind:style="
                getAvatarColor(
                  userInfo ? userInfo.username.charAt(0).toUpperCase() : 'A'
                )
              "
              >{{
                userInfo
                  ? translateUserType(userInfo.userType).substring(0, 2)
                  : "-"
              }}</el-avatar
            >
          </div>
          <!-- <img class="user-avatar" :src="userInfo.icon"> -->
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <!-- <router-link class="inlineBlock" to="/setting/general">
            <el-dropdown-item>
              系统设置
            </el-dropdown-item>
          </router-link> -->
          <!-- <el-dropdown-item divided>
            身份：{{ userInfo ? userInfo.userType : '-' }}
          </el-dropdown-item> -->
          <!-- <router-link class="inlineBlock" to="/">
            <el-dropdown-item>
              首页
            </el-dropdown-item>
          </router-link> -->
          <!-- <el-dropdown-item divided>
            版號：{{ userInfo.userType }}
          </el-dropdown-item> -->
          <el-dropdown-item>
            <span style="display: block"
              >{{ userInfo ? userInfo.username : "-" }} (
              {{ userInfo ? translateUserType(userInfo.userType) : "" }} )</span
            >
          </el-dropdown-item>
          <el-dropdown-item>
            <span
              @click="passwordDialogObj = { visible: true }"
              style="display: block"
              >密码设置</span
            >
          </el-dropdown-item>
          <el-dropdown-item>
            <span @click="logout" style="display: block">登出管理</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-menu>
    <StickyNote />

    <!-- 修改密码 -->
    <PasswordDialog :password-dialog-obj.sync="passwordDialogObj" />
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import methodCommon from "@/utils/methodCommon";
import { mapGetters } from "vuex";
import StickyNote from "./StickyNote";
import PasswordDialog from "@/views/profile/my/PasswordDialog";

export default {
  mixins: [methodCommon],
  components: {
    Breadcrumb,
    Hamburger,
    StickyNote,
    PasswordDialog,
  },
  computed: {
    ...mapGetters(["sidebar", "userInfo", "routers"]),
  },
  data() {
    return {
      searchRouters: [],
      querySearchData: "",
      passwordDialogObj: {}, // 修改密码 obj
    };
  },
  methods: {
    // 改变头像背景颜色
    getAvatarColor(char) {
      let uid = "ABCDEFGHIJKLMNOPQRSTUVXYZ0123456789";
      let colorArray = [
        "#EE6B00",
        "#F14B2C",
        "#FCBB00",
        "#F3389F",
        "#788F9C",
        "#24C1DF",
        "#4085F3",
      ];
      return `background: ${colorArray[uid.indexOf(char) % colorArray.length]}`;
    },
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        location.reload();
      });
    },
    // 来做个搜索框吧
    querySearch(queryString, cb) {
      this.searchRouters = this.loadAllRouterList();
      var searchRouters = this.searchRouters;
      var results = queryString
        ? searchRouters.filter(this.createFilter(queryString))
        : searchRouters;
      cb(results);
    },
    createFilter(queryString) {
      // value、path 都可以作为搜索条件
      return (searchRouter) => {
        return (
          searchRouter.value
            .toLowerCase()
            .includes(queryString.toLowerCase()) ||
          searchRouter["path"].toLowerCase().includes(queryString.toLowerCase())
        );
      };
    },
    loadAllRouterList() {
      let returnRouterArray = [];
      if (this.routers) {
        this.routers.forEach((element) => {
          if (element.meta && element.meta.title) {
            if (element.children) {
              element.children.forEach((el) => {
                returnRouterArray.push({
                  value: el.meta.title,
                  path: element.path + "/" + el.path,
                });
              });
            }
          }
        });
      }
      return returnRouterArray;
    },
    handleSelect(item) {
      this.$router.push(item.path);
      this.querySearchData = "";
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      .el-avatar {
        color: #ffeba4;
      }
      .user-name {
        position: absolute;
        right: 0px;
        top: 0px;
        font-weight: 600;
      }
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 15px; // 15px
        font-size: 12px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue